import { Component, Input } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { EntityMap, Product } from '../../../../../core/model';
import { prepareUrlForLink } from '../../../../../core/util';
import { BadgeType } from '../../../badge';

@Component({
  selector: 'py-campaign-extra-small-items',
  templateUrl: './campaign-extra-small-items.component.html',
  styleUrls: ['./campaign-extra-small-items.component.scss'],
  standalone: false,
})
export class CampaignExtraSmallItemsComponent {
  products$: Observable<Array<Product>>;

  @Input() queryParams: EntityMap<string>;
  @Input() badgeType: BadgeType;

  @Input()
  set products(products: Array<Observable<Product>>) {
    this.products$ = combineLatest(products) as Observable<Array<Product>>;
  }

  getUrl(url: string): string {
    return prepareUrlForLink(url, this.queryParams);
  }
}
